import { Box, Button, Paper, Typography, Link } from "@mui/material";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import PBALogo from "../resources/images/PBA Logo.png";

function Login() {
  const { login, register } = useKindeAuth();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      sx={{ px: 2 }}
    >
      <Paper
        elevation={3}
        sx={{ padding: 4, width: { xs: "100%", sm: 300 }, maxWidth: 400 }}
      >
        <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
          <img
            src={PBALogo}
            alt="PBA Logo"
            style={{ height: 150, objectFit: "contain" }}
          />
        </Box>
        <Typography variant="h5" align="center" sx={{ mb: 3 }}>
          PBA Ranking System
        </Typography>
        <Box display={"flex"} justifyContent={"center"} gap={2}>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => login()}
          >
            Login
          </Button>

          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => register()}
          >
            Sign Up
          </Button>
        </Box>
      </Paper>

      <Box sx={{ mt: 4, maxWidth: 500, px: 2 }}>
        <Typography
          variant="body1"
          sx={{ mb: 2, textAlign: "center", lineHeight: 1.6 }}
        >
          Welcome to the PBA South Africa ranking system. Here you can add your
          own events and keep rankings up to date. We also have a flagging
          system, so if you notice anything unusual, please flag it. This helps
          us enormously and keeps everyone accountable.
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 3,
            flexWrap: "wrap",
          }}
        >
          <Link
            href="https://bowlsmaster.co.za/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: "0.9rem" }}
          >
            Privacy Policy
          </Link>
          <Typography sx={{ fontSize: "0.9rem" }}>•</Typography>
          <Link
            href="https://bowlsmaster.co.za/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: "0.9rem" }}
          >
            Terms of Service
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
